import { EmailClientDto } from "@/entities/email";
import { EmailFormData } from "@/entities/emailFormData";
import { EmailService } from "@/services/EmailService";

export function useEmail() {
    const sendEmailCliente = async (email: EmailClientDto) => {
        const response = await EmailService.sendEmailClient(email);
      };

    const getEmailConfig = async (userId: number) => {
      const response = await EmailService.getEmailConfig(userId);
      return response;
    }

    const getTemplates = async () => {
      const response = await EmailService.getTemplates();
      return response;
    }

    const sendEmail = async (data: FormData) => {
      const response = await EmailService.sendEmail(data);
      return response;
    }

    const addEmailConfig = async (userId: number, email: string, password: string) => {
      const response = await EmailService.addEmailConfig(userId, email, password);
      return response ;
    }
    
    return{ sendEmailCliente, getEmailConfig, getTemplates, sendEmail, addEmailConfig };
}
